publishingApp.controller('notificationsCtrl', ['$scope', '$rootScope', '$state', 'dbData', function ($scope, $rootScope, $state, dbData) {
    $scope.notifications = [];

    dbData.get('notifications').then(function (response) {

        angular.forEach(response.data, function(element, key){

            // Get specific date format, extra day, month and year from given date, then convert month to calendar month in string
            var date = new Date(element.created_at);
            var month = date.getUTCMonth();
            var day = date.getUTCDate();
            var year = date.getUTCFullYear();

            function monthName(number) {
                var monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December' ];
                return monthNames[number];
            }

            var data = {
                id: element.id,
                monthYear: monthName(month) + ' ' + year,
                day: day,
                content: element.notify_body,
                notification_class: 'notification_type_' + element.category_id,
                read: element.read,
                created_at: element.created_at
            };

            $scope.notifications.splice(key, 1, data);

        });

    }, function (error) {
        $scope.pushAlerts('Unable to retrieve notifications at this moment.');
    });

    // Mark Notification read
    $scope.markRead = function(id){
        dbData.post('/notifications/mark-as-read/' + id).then(function (response) {
            angular.forEach($scope.notifications, function(element, key){
                if(element.id == id){
                    $scope.notifications[key].read = 1;
                }
            });

        });
    };

    // Delete Notification
    $scope.delete = function(id){
        dbData.delete('/notifications/' + id).then(function (response) {
            angular.forEach($scope.notifications, function(element, key){
                if(element.id == id){
                    $scope.notifications.splice(key, 1);

                }
            });

        });
    };

}]);